import { useState } from 'react';
import { Box, Button, SvgIcon, SxProps } from '@mui/material';
import { overlayPlayIcon } from '../config/icons';

export type PlayOverlayProps = {
  onClick?: () => void;
  label?: string;
  sx?: SxProps;
  testKey?: string;
  children?: React.ReactNode;
};

export function PlayOverlay({ onClick, label, sx, testKey, children }: PlayOverlayProps) {
  const [showOverlay, setShowOverlay] = useState(true);

  const handleClick = () => {
    setShowOverlay(false);
    onClick && onClick();
  };

  return showOverlay ? (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.40) 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          userSelect: 'none',
          gap: 2,
          ...sx,
        }}
      >
        <Button
          variant="contained"
          onClick={handleClick}
          sx={{
            display: 'flex',
            padding: '8px 14px',
            alignItems: 'center',
            fontSize: '18px',
            gap: '10px',
            borderRadius: '200px',
            background: 'rgba(0, 0, 0, 0.40)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            color: '#fff',
            '&:hover': {
              background: 'rgba(0, 0, 0, 0.20)',
              color: 'white',
            },
          }}
          data-treedistestid={testKey}
        >
          <SvgIcon
            sx={{
              width: '20px',
              height: '28px',
            }}
          >
            {overlayPlayIcon}
          </SvgIcon>
          {label && label}
        </Button>
        {children}
      </Box>
    </>
  ) : null;
}
